const Guidelines = () => {
    return (
        <div className="h-screen w-screen flex items-center">
            <div className="container flex flex-col md:flex-row items-center justify-center px-5 text-gray-700">
                <div className="max-w-md">
                    <div className="text-7xl font-dark font-bold">503</div>
                    <p
                        className="text-5xl md:text-4xl font-light leading-normal"
                    >Sorry this page is currently in under construction </p>
                    <p className="mb-8">But dont worry, you can find plenty of other things on our website.</p>

                    {/* <button className="px-4 inline py-2 text-sm font-medium leading-5 shadow text-white transition-colors duration-150 border border-transparent rounded-lg focus:outline-none focus:shadow-outline-blue bg-blue-600 active:bg-blue-600 hover:bg-blue-700" onClick={() => { navigate("/") }}>Back to homepage</button> */}
                </div>
                <div className="max-w-lg">
                </div>
            </div>
        </div>
    )
}

export default Guidelines